var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopcontentEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 201,
    viewBox: "0 0 200 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_186_23878)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100.8,
    r: 87.5,
    fill: "#E9E5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.303 165.268L171.199 45.3636C171.587 43.8048 171.199 42.4853 170.455 41.2439L167.022 36.3776L158.216 38.6005L82.834 32.0054C79.7114 31.7322 76.5652 33.9764 75.8069 37.0179L47.2134 151.7L42.547 155.147L46.6145 160.987C47.3907 162.059 48.6431 162.789 50.1923 162.924L134.276 170.281C137.399 170.554 140.545 168.31 141.303 165.268Z",
    fill: "#A995FF",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 95.7562,
    height: 134.927,
    rx: 5.09422,
    transform: "matrix(0.996195 0.0871557 -0.241922 0.970296 73.4199 26.1934)",
    fill: "url(#paint0_linear_186_23878)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.87862,
    cy: 6.87862,
    r: 6.87862,
    transform: "matrix(0.996195 0.0871557 -0.241922 0.970296 78.668 32.0286)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5945,
    cy: 2.5945,
    r: 2.5945,
    transform: "matrix(0.996195 0.0871557 -0.241922 0.970296 82.4336 34.4199)",
    fill: "#611FE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.9637 43.7761C79.05 41.8646 81.2733 40.5951 83.4829 40.7884C85.6926 40.9817 87.2014 42.5777 87.3085 44.5937C85.8072 45.5984 83.995 46.135 82.1893 45.977C80.3835 45.819 78.9106 44.995 77.9637 43.7761Z",
    fill: "#611FE2"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 95.7562,
    height: 78.7751,
    transform: "matrix(0.996195 0.0871557 -0.241922 0.970296 67.6504 49.3416)",
    fill: "url(#paint1_linear_186_23878)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8317 85.2409L60.5151 112.389C58.6363 114.017 59.2709 116.729 61.5781 116.931L135.412 123.391C137.794 123.599 139.735 120.961 138.573 119.097L125.716 98.4865C124.937 97.2372 123.095 97.0438 121.708 98.0656L109.895 106.767C108.41 107.86 106.435 107.551 105.762 106.119L96.1789 85.7167C95.4651 84.197 93.3081 83.9609 91.8317 85.2409Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9629 37.6814L121.638 39.8402",
    stroke: "#8963FE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5684 142.564L70.8611 144.164",
    stroke: "#BEB1FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4375 133.835L71.0746 134.591",
    stroke: "#BEB1FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9941 135.984L95.6312 136.74",
    stroke: "#BEB1FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4707 43.6655L108.236 44.7823",
    stroke: "#BEB1FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0781 148.548L130.489 155.495",
    stroke: "#BEB1FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.0048,
    cy: 12.0048,
    r: 12.0048,
    transform: "matrix(0.996195 0.0871557 -0.241922 0.970296 124.744 65.7092)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2161 130.486C56.3701 130.371 56.5175 130.25 56.6766 130.146C57.5357 129.585 58.5123 129.544 59.1395 130.038C59.7857 130.548 59.9338 131.514 59.4884 132.377C59.0842 133.161 58.4295 133.75 57.721 134.292C56.8548 134.955 55.9119 135.489 54.9532 135.994C54.8933 136.025 54.7745 136.033 54.7397 136C53.818 135.107 52.9344 134.184 52.4126 132.99C52.1787 132.456 52.0419 131.89 52.1864 131.258C52.3767 130.426 53.0476 129.707 53.8482 129.466C54.6516 129.224 55.4832 129.488 55.9568 130.136C56.0379 130.247 56.1206 130.357 56.2161 130.486Z",
    fill: "#8963FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5651 136.849C82.9793 136.394 83.2885 135.848 83.4381 135.247C83.8799 133.476 82.7633 131.91 80.9442 131.751C79.1251 131.592 77.2923 132.899 76.8505 134.671C76.4087 136.443 77.5253 138.008 79.3444 138.167C79.9619 138.221 80.5809 138.107 81.1466 137.862L82.6043 138.405L82.5651 136.849Z",
    fill: "#8963FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0467 60.6764C67.4036 52.5417 66.0821 48.4744 63.4443 45.7135C61.1241 43.2849 58.1168 41.5486 54.8535 40.7535C51.1436 39.8497 46.9604 40.7388 38.594 42.5172L34.1661 43.4583C25.7998 45.2367 21.6166 46.1258 18.9354 48.3882L17.4027 48.0454L15.4956 52.8749C15.0189 53.8981 14.673 54.9877 14.4695 56.1234C13.8508 59.5765 15.1724 63.6438 17.8155 71.7785L19.2144 76.0837C21.8575 84.2184 23.179 88.2857 25.8168 91.0467C28.137 93.4753 31.1443 95.2115 34.4076 96.0066C38.1175 96.9105 42.3007 96.0213 50.667 94.243L55.0949 93.3018C63.4613 91.5235 67.6445 90.6343 70.3256 88.372C71.9979 86.9609 73.2704 85.189 74.0633 83.1945L76.1855 77.8781L74.9223 79.5362C75.1212 76.2942 73.814 72.2708 71.4456 64.9816L70.0467 60.6764Z",
    fill: "#A925C3",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2268 55.2226C69.5837 47.0879 68.2621 43.0206 65.6244 40.2597C63.3042 37.8311 60.2969 36.0948 57.0336 35.2998C53.3237 34.3959 49.1405 35.285 40.7741 37.0634L36.3462 38.0045C27.9798 39.7829 23.7967 40.672 21.1155 42.9344C18.7571 44.9244 17.1938 47.6322 16.6496 50.6696C16.0309 54.1227 17.3525 58.19 19.9956 66.3247L21.3944 70.6299C24.0376 78.7646 25.3591 82.8319 27.9968 85.5929C30.3171 88.0214 33.3243 89.7577 36.5877 90.5528C40.2976 91.4567 44.4808 90.5675 52.8471 88.7892L57.275 87.848C65.6414 86.0697 69.8246 85.1805 72.5057 82.9182C74.8641 80.9281 76.4275 78.2204 76.9717 75.1829C77.5903 71.7298 76.2688 67.6625 73.6257 59.5279L72.2268 55.2226Z",
    fill: "#B936D3",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6471 44.9547L38.9408 80.3853M67.2993 73.2557L28.6157 51.2707",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.213 117.872L190.37 111.95L190.985 114.864C188.725 112.631 184.846 111.295 177.089 108.624C169.332 105.952 165.454 104.617 161.649 104.761C157.159 104.931 152.651 106.482 149.008 109.112C145.922 111.341 143.687 114.781 139.219 121.661C134.75 128.542 132.516 131.982 132.108 135.133L130.126 135.441L133.023 141.47C133.091 141.621 133.163 141.77 133.238 141.918C133.806 143.039 134.356 143.955 135.338 145.07C136.69 146.604 137.732 147.606 140.68 148.862C141.308 149.13 141.622 149.263 141.853 149.424C142.072 149.576 142.234 149.724 142.404 149.929C142.584 150.146 142.726 150.414 143.012 150.95L143.926 152.667C144.601 153.937 144.939 154.571 145.444 154.943C145.89 155.271 146.423 155.457 146.975 155.477C147.602 155.501 148.262 155.214 149.58 154.641L152.321 153.449C152.893 153.2 153.179 153.075 153.473 153.018C153.738 152.966 153.996 152.953 154.265 152.978C154.563 153.006 154.869 153.105 155.482 153.302C159.5 154.593 162.19 155.213 164.844 155.112C169.334 154.942 173.842 153.39 177.485 150.76C180.572 148.532 182.806 145.092 187.275 138.212C191.744 131.331 193.978 127.891 194.385 124.74C194.665 122.571 194.37 120.47 193.546 118.572C193.443 118.336 193.332 118.102 193.213 117.872Z",
    fill: "#DC466D",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.396 132.221C188.865 125.34 191.099 121.9 191.506 118.749C191.987 115.03 190.774 111.508 188.106 108.873C185.846 106.64 181.967 105.305 174.21 102.633C166.453 99.9616 162.575 98.6259 158.77 98.7698C154.28 98.9397 149.773 100.492 146.129 103.122C143.043 105.35 140.808 108.79 136.34 115.67C131.871 122.551 129.637 125.991 129.229 129.142C128.749 132.861 129.961 136.383 132.629 139.018C134.165 140.535 136.194 141.518 139.85 142.869C140.708 143.186 141.137 143.344 141.439 143.584C141.71 143.799 141.908 144.053 142.039 144.352C142.184 144.685 142.196 145.086 142.221 145.889C142.288 148.016 142.321 149.079 142.875 149.628C143.377 150.125 144.146 150.389 144.992 150.356C145.927 150.318 147.056 149.673 149.314 148.381C150.152 147.902 150.571 147.662 151.004 147.533C151.41 147.412 151.798 147.36 152.207 147.374C152.64 147.389 153.085 147.524 153.975 147.794C157.327 148.813 159.561 149.212 161.965 149.121C166.455 148.951 170.963 147.399 174.606 144.769C177.693 142.541 179.927 139.101 184.396 132.221Z",
    fill: "#F56087",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.487 114.028C164.315 109.577 158.942 107.259 153.486 108.851C148.03 110.443 144.558 115.341 145.73 119.791L148.883 131.763L148.603 131.767L149.911 135.584C149.918 135.601 149.926 135.619 149.934 135.636C150.398 136.622 151.709 137.101 153.039 136.713L172.08 131.158C177.535 129.566 181.008 124.668 179.836 120.217C179.711 119.745 179.528 119.17 179.359 118.723L178.142 115.408L176.266 115.769C173.978 114.49 170.92 114.14 167.835 115.04L165.902 115.604L165.487 114.028Z",
    fill: "#CABCF2",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.212 110.385C163.04 105.934 157.667 103.617 152.211 105.208C146.755 106.8 143.283 111.698 144.455 116.149L148.546 131.682C148.86 132.875 150.301 133.497 151.764 133.07L170.805 127.515C176.26 125.923 179.733 121.025 178.561 116.575C177.388 112.124 172.016 109.806 166.56 111.398L164.627 111.962L164.212 110.385Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.6612,
    cy: 121.95,
    r: 2.38187,
    fill: "#611FE2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.5635,
    cy: 30.9829,
    r: 2.38187,
    fill: "#611FE2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.159,
    cy: 94.9024,
    r: 2.38187,
    fill: "#611FE2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.9011,
    cy: 109.586,
    r: 4.34443,
    fill: "#611FE2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 169.567,
    cy: 86.0068,
    r: 4.34443,
    fill: "#611FE2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.3171,
    cy: 174.185,
    r: 4.34443,
    fill: "#611FE2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_186_23878",
    x1: 47.8781,
    y1: 0,
    x2: 47.8781,
    y2: 134.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBE7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_186_23878",
    x1: 47.8781,
    y1: 0,
    x2: 47.8781,
    y2: 78.7751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#875FFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7148EC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_186_23878"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white",
    transform: "translate(0 0.800049)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopcontentEmpty);
export default __webpack_public_path__ + "static/media/topcontent-empty.05642f95fed50347406054e556b65e33.svg";
export { ForwardRef as ReactComponent };